// 返回年月日
export function formatDate(data){
  if(data.constructor != Date){
    throw new Error('输入的值必须为日期')
  }
  let year,month,date
  year = data.getFullYear()
  month = data.getMonth()+1
  date = data.getDate()
  return `${year}-${month}-${date}`
}

// 返回时分秒
export function formatTime(data){
  if(data.constructor != Date){
    throw new Error('输入的值必须为日期')
  }
  let hours,minutes,seconds
  hours = data.getHours()<10 ? '0'+data.getHours() : data.getHours()
  minutes = data.getMinutes()<10 ? '0'+data.getMinutes() : data.getMinutes()
  seconds = data.getSeconds()<10 ? '0'+data.getSeconds() : data.getSeconds()

  return `${hours}:${minutes}:${seconds}`
}

// 返回月日
export function formatMonthDate(data){
  if(data.constructor != Date){
    throw new Error('输入的值必须为日期')
  }
  let month,date
  month = data.getMonth()+1
  date = data.getDate()
  return `${month}-${date}`
}

// 返回时分
export function formatHourMinute(data){
  if(data.constructor != Date){
    throw new Error('输入的值必须为日期')
  }
  let hours,minutes
  hours = data.getHours()<10 ? '0'+data.getHours() : data.getHours()
  minutes = data.getMinutes()<10 ? '0'+data.getMinutes() : data.getMinutes()

  return `${hours}:${minutes}`
}

export function format_hit(data){
  let datacache = JSON.parse(data)
  // console.log(data,"format_hit")
  // let value = {}
  // for(let s in datacache){
  //   for(let p in datacache[s].similar_faces){
  //     if(!value.similarity){
  //       value = datacache[s].similar_faces[p]
  //     }else if(value.similarity < datacache[s].similar_faces[p].similarity){
  //       value = datacache[s].similar_faces[p]
  //     }
  //   }
  // }
  
  // console.log(value)
  // value.extra_meta_format = JSON.parse(value.extra_meta)
  return datacache
}


export function getBase64(file) {
  return new Promise(function(resolve, reject) {
    let reader = new FileReader();
    let imgResult = "";
    reader.readAsDataURL(file);
    reader.onload = function() {
      imgResult = reader.result;
    };
    reader.onerror = function(error) {
      reject(error);
    };
    reader.onloadend = function() {
      resolve(imgResult);
    };
  });
}